import { ValidationFeedback } from './listValidator'
import { ValidationGovernanceOwner } from '../validationTypes'

/**
 * Validate the drill down list.
 * - Value must be in list
 * - If no value, allow required error if required.
 * @param {string | undefined} value The cell value.
 * @param {Array} source
 * @param governanceOwner Template field if is variable type, otherwise it's templateField.field.
 * @param feedback Object containing errors and warnings.
 */
export function validateDrilldownList(
  value: string | undefined,
  source: any[],
  governanceOwner: ValidationGovernanceOwner,
  feedback: ValidationFeedback,
) {
  const listGovernance = governanceOwner?.list_governance
  const parentTf = listGovernance?.meta.allColumnsInList[0]
  const isVariable = parentTf?.field.segment_type === 'variable'
  const parentGovernanceOwner = isVariable ? parentTf : parentTf?.field
  const isRequired = !!governanceOwner?.required
  const delimiter = parentGovernanceOwner?.list_governance?.delimiter

  if (value) {
    const values = delimiter ? value.split(delimiter) : [value]
    values.forEach(val => {
      if (listGovernance?.hierarchy) {
        if (val && !listGovernance?.lists.possible_hierarchy_values.includes(val)) {
          feedback.errors.push(`Value must be in list`)
        }
      } else if (val && !source.includes(val)) {
        feedback.errors.push(`Value must be in list`)
      }
    })
  } else if (!value && source.length > 0 && isRequired) {
    feedback.errors.push(`Value must be in list`)
  }
}
